import { defineComponent as o, openBlock as r, createBlock as n, unref as i, withCtx as a, createElementVNode as f } from "vue";
import s from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as l } from "@storefront-ui/shared";
const u = /* @__PURE__ */ o({
  __name: "SfIconChevronRight",
  props: {
    size: {
      type: String,
      default: l.base
    }
  },
  setup(t) {
    return (m, e) => (r(), n(i(s), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "chevron-right"
    }, {
      default: a(() => e[0] || (e[0] = [
        f("path", { d: "M8.705 17.297a1 1 0 0 1-.001-1.41l3.876-3.885-3.876-3.885a.998.998 0 0 1 1.412-1.41l4.587 4.588a1 1 0 0 1 0 1.414l-4.587 4.588a.997.997 0 0 1-1.411 0" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  u as default
};
